import styled from 'styled-components';

export const ListModifier = styled.div`
  width: 100%;
  margin-top: 8px;
  margin-bottom: 0px !important;
  > div {
    margin-bottom: 0px !important;
  }
`;

export const ListItemModifier = styled.div`
  > label {
    width: 100%;
    align-items: center !important;
    flex-direction: row-reverse;
    justify-content: flex-end;
    height: auto;
    padding-top: 16px;

    @media (min-width: 768px) {
      padding-top: 8px;
    }

    > div:nth-child(2) > div {
      padding: 0 12px 0 0;
    }
  }
  div {
    margin: 0 !important;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > svg {
    align-self: center;
  }
`;
